// DD-3800: Production › Overview page models. The GraphQL contract these mirror is the
// backend's production-overview module (one count query per row group, plus a snapshot
// and a click-through order list that share the exact same filters).

export type ProductionOverviewCount = {
    orderCount: number;
    actionCount: number;
};

export type ProductionOverviewDayCount = ProductionOverviewCount & {
    /** Calendar day in the lab timezone, formatted "YYYY-MM-DD". */
    day: string;
};

export type ProductionOverviewReceived = {
    byCustomer: ProductionOverviewDayCount[];
    viaScannerCase: ProductionOverviewDayCount[];
    viaOrderForm: ProductionOverviewDayCount[];
    createdManually: ProductionOverviewDayCount[];
};

export type ProductionOverviewProduction = {
    productionFinished: ProductionOverviewDayCount[];
    sentToClinic: ProductionOverviewDayCount[];
    deadline: ProductionOverviewDayCount[];
    deliveryToCustomer: ProductionOverviewDayCount[];
    lateToday: ProductionOverviewCount;
    withoutDeadline: ProductionOverviewCount;
};

export type ProductionOverviewSnapshotStep = {
    /** The pseudo step 'NO_STEP' (empty stepName) collects orders outside any workflow step. */
    stepId: string;
    stepName: string;
    orderCount: number;
    lateCount: number;
    pausedCount: number;
};

export type ProductionOverviewSnapshotDepartment = {
    /** Both null for the "No department" group holding steps outside every department. */
    departmentId: string | null;
    departmentName: string | null;
    steps: ProductionOverviewSnapshotStep[];
};

export enum ProductionOverviewRowKey {
    INBOX = 'INBOX',
    /** A Received group-total cell: every origin for that day in one list. */
    RECEIVED_ALL = 'RECEIVED_ALL',
    RECEIVED_BY_CUSTOMER = 'RECEIVED_BY_CUSTOMER',
    RECEIVED_SCANNER_CASE = 'RECEIVED_SCANNER_CASE',
    RECEIVED_ORDER_FORM = 'RECEIVED_ORDER_FORM',
    RECEIVED_MANUAL = 'RECEIVED_MANUAL',
    PRODUCTION_FINISHED = 'PRODUCTION_FINISHED',
    SENT_TO_CLINIC = 'SENT_TO_CLINIC',
    DEADLINE = 'DEADLINE',
    LATE_TODAY = 'LATE_TODAY',
    WITHOUT_DEADLINE = 'WITHOUT_DEADLINE',
    DELIVERY_TO_CUSTOMER = 'DELIVERY_TO_CUSTOMER',
    SNAPSHOT_STEP = 'SNAPSHOT_STEP',
}

/** Identifies one clicked number; the backend returns exactly the orders behind it. */
export type ProductionOverviewCellInput = {
    rowKey: ProductionOverviewRowKey;
    day?: string;
    stepId?: string;
    isPaused?: boolean;
    isLate?: boolean;
    clinicId?: string;
};

export enum ProductionOverviewCountMode {
    ORDERS = 'ORDERS',
    ACTIONS = 'ACTIONS',
}

export enum ProductionOverviewPeriod {
    FOURTEEN_DAYS = 'FOURTEEN_DAYS',
    THIRTY_DAYS = 'THIRTY_DAYS',
    CUSTOM = 'CUSTOM',
}

/** How the order reached the lab; the backend derives it (came-in-via service). */
export enum OrderCameInVia {
    BY_CUSTOMER = 'BY_CUSTOMER',
    SCANNER_CASE = 'SCANNER_CASE',
    ORDER_FORM = 'ORDER_FORM',
    MANUAL = 'MANUAL',
}
